// extracted by mini-css-extract-plugin
export default {"content-wrapper":"ContentWrapper_content-wrapper__qPet5"};